import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import ConsolidadoEspeciales from "./ConsolidadoEspeciales";

const cookies = new Cookies();

function InfoEspecialesAyR() {
  const [todasSolicitudes, setTodasSolicitudes] = useState([]);
  const [filtroTexto, setFiltroTexto] = useState("");
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("13");
  const [solicitudesFiltradas, setSolicitudesFiltradas] = useState([]);

  const tipoUsuario = Number(cookies.get("tipo_Usuario"));
  const idRegional = cookies.get("id");

  const [paginaActual, setPaginaActual] = useState(1);
  const solicitudesPorPagina = 10;

  // Obtener todas las solicitudes una vez
  useEffect(() => {
    obtenerSolicitudes();
  }, []);

  // Aplicar filtro por estado cuando cambie
  useEffect(() => {
    if (todasSolicitudes.length > 0) {
      const filtradas = todasSolicitudes.filter(
        (item) => String(item.estado) === estadoSeleccionado
      );
      setSolicitudesFiltradas(filtradas);
      setPaginaActual(1);
    }
  }, [estadoSeleccionado, todasSolicitudes]);

  const obtenerSolicitudes = async () => {
    try {
      let url = "";

      if (tipoUsuario === 2) {
        url = "https://educacionapi.azurewebsites.net/api/ObtenerTodos/admin/0";
      } else if (tipoUsuario === 3 && idRegional) {
        url = `https://educacionapi.azurewebsites.net/api/ObtenerTodos/0/${idRegional}`;
      } else {
        console.warn("Tipo de usuario o ID regional no válidos.");
        return;
      }

      const response = await axios.get(url, {
        auth: {
          username: "webapp",
          password: "762tsfsy9826kk87ytttsf",
        },
      });

      setTodasSolicitudes(response.data);
      setSolicitudesFiltradas(response.data); // se filtra después
    } catch (error) {
      console.error("Error al obtener solicitudes:", error);
    }
  };

  const handleBuscar = () => {
    setPaginaActual(1);
    const filtradas = todasSolicitudes.filter(
      (item) => String(item.estado) === estadoSeleccionado
    );
    setSolicitudesFiltradas(filtradas);
  };

  // Filtro por texto (nombre del cliente)
  const solicitudesBuscadas = solicitudesFiltradas.filter((item) =>
    item.nombreCliente?.toLowerCase().includes(filtroTexto.toLowerCase())
  );

  // Paginación
  const indexUltimo = paginaActual * solicitudesPorPagina;
  const indexPrimero = indexUltimo - solicitudesPorPagina;
  const solicitudesPagina = solicitudesBuscadas.slice(
    indexPrimero,
    indexUltimo
  );
  const totalPaginas = Math.ceil(
    solicitudesBuscadas.length / solicitudesPorPagina
  );

  const handleAnterior = () => {
    setPaginaActual((prev) => Math.max(prev - 1, 1));
  };

  const handleSiguiente = () => {
    setPaginaActual((prev) => Math.min(prev + 1, totalPaginas));
  };

  return (
    <div className="container">
      <div className="text-center">
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">
              Solicitudes Aprobadas/Rechazadas
            </h6>
          </div>

          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-4">
                <select
                  className="form-control"
                  value={estadoSeleccionado}
                  onChange={(e) => setEstadoSeleccionado(e.target.value)}
                >
                  <option value="13">Aprobado</option>
                  <option value="14">Rechazado</option>
                </select>
              </div>

              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por nombre del cliente..."
                  value={filtroTexto}
                  onChange={(e) => setFiltroTexto(e.target.value)}
                />
              </div>
            </div>

            <div className="table-responsive">
              <table
                className="table table-bordered"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nombre cliente</th>
                    <th>Línea de servicio</th>
                    <th>Estado</th>
                    <th>Fecha Creación</th>
                    <th>Consultar</th>
                  </tr>
                </thead>
                <tbody>
                  {solicitudesPagina.length > 0 ? (
                    solicitudesPagina.map((item) => {
                      const fecha = new Date(item.fechaCreacion);
                      return (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.nombreCliente}</td>
                          <td>{item.lineaServicio}</td>
                          <td>{item.estados}</td>
                          <td>{fecha.toLocaleDateString("es-CO")}</td>
                          <td>
                            <ConsolidadoEspeciales {...item} />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-muted">
                        No hay resultados
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Paginación */}
            {solicitudesBuscadas.length > 10 && (
              <div className="d-flex justify-content-between mt-3">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleAnterior}
                  disabled={paginaActual === 1}
                >
                  ← Anterior
                </button>
                <span className="align-self-center">
                  Página {paginaActual} de {totalPaginas}
                </span>
                <button
                  className="btn btn-outline-primary"
                  onClick={handleSiguiente}
                  disabled={paginaActual === totalPaginas}
                >
                  Siguiente →
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoEspecialesAyR;
